import * as React from 'react';

export interface ThumbnailProps {
  readonly src?: string;
  readonly width: number;
  readonly height: number;
  readonly label?: string;
  readonly labelAlign?: 'left' | 'right';
  readonly onClick?: () => any;
}

const labelBaseStyle: Readonly<React.CSSProperties> = {
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  minWidth: '1em',
  textAlign: 'center',
  display: 'inline-block',
  borderColor: '#888',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderBottom: 'none',
  position: 'absolute',
  bottom: 0,
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
};

const labelLeftStyle: Readonly<React.CSSProperties> = {
  ...labelBaseStyle,
  borderLeft: 'none',
  left: 0,
};

const labelRightStyle: Readonly<React.CSSProperties> = {
  ...labelBaseStyle,
  borderRight: 'none',
  right: 0,
};

function labelStyle(isRight: boolean,
                    width: number,
                    height: number): Readonly<React.CSSProperties> {
  return {
    ...(isRight ? labelRightStyle : labelLeftStyle),
    maxWidth: width,
    maxHeight: height,
  };
}

const Thumbnail: React.SFC<ThumbnailProps> = (props: ThumbnailProps) => {
  const { width, height, src, label, labelAlign, onClick } = props;
  const image = src ? `url(${src})` : 'url(/images/misc/alt-thumbnail.png)';
  const style: React.CSSProperties = {
    width,
    height,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundColor: '#FFF',
    backgroundImage: image,
    display: 'inline-block',
    position: 'relative',
  };
  return <div style={style} onClick={onClick} title={label}>
    {label && <div style={labelStyle(labelAlign === 'right', width, height)}>{label}</div>}
  </div>;
};

export default Thumbnail;
